import styled from 'styled-components';
import { space, ContainerProps, SpaceProps } from 'styled-system';

const Spacer = styled.div<ContainerProps & SpaceProps>(space);

export default Spacer;
